import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  ORDER_DETAILS_BLOCK_DATA_SOURCE,
  OrderDetailsBlockDataSource,
} from './order-details-block-view-model';
import { OrderDetailsBlockPreviewDataSource } from './order-details-block-preview-data-source';
import { OrderDetailsBlockStoreDataSource } from './order-details-block-store-data-source';

export function provideOrderDetailsBlockDataSource(): Provider[] {
  return [
    OrderDetailsBlockStoreDataSource,
    OrderDetailsBlockPreviewDataSource,
    {
      provide: ORDER_DETAILS_BLOCK_DATA_SOURCE,
      useFactory: (): OrderDetailsBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(OrderDetailsBlockPreviewDataSource)
          : inject(OrderDetailsBlockStoreDataSource);
      },
    },
  ];
}
